import { render } from "./CustomerSectionClassification.vue?vue&type=template&id=2196515f"
import script from "./CustomerSectionClassification.vue?vue&type=script&lang=js"
export * from "./CustomerSectionClassification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__